export default {
    state: {
        units: []
    },
    mutations: {
        setUnits (state, payload) {
            state.units = payload
        }
    },
    actions: {
        getUnits (context, data) {
            return new Promise((resolve, reject) => {
                this._vm.axios.get('/api/units/' + data.publication_id + '/' + data.unit_id)
                .then(response => {
                    let units = []

                    if (response.data) {
                        units = response.data
                    }

                    context.commit('setUnits', units)

                    resolve(response)
                })
                .catch(error => {
                    reject(error)
                })
            })
        }
    }
}
